<ng-template [ngIf]="loaded">
  <app-edtell-ag-grid [config]="agGridConfig"></app-edtell-ag-grid>
</ng-template>
